import React from "react";
import "./blogTemplate.css";

// Define Heading type
type Heading = {
  text: string;
  date: string;
  style?: React.CSSProperties;
};

// Content types
type BlueText = { type: "bluetext"; text: string; style: React.CSSProperties };
type Image = { type: "image"; path: string; style: React.CSSProperties };
type Paragraph = {
  type: "paragraph";
  text: string;
  style: React.CSSProperties;
};
type List = {
  type: "list";
  style: React.CSSProperties;
  listItem: { boldtext: string; text: string }[];
};
type BoldText = {
  type: "boldtext";
  text: string;
  style: React.CSSProperties;
};

// ContentType is now an array of the different types
export type ContentType = (BlueText | Image | Paragraph | List | BoldText)[];

const BlogTemplate = ({
  heading,
  content,
}: {
  heading: Heading;
  content: ContentType;
}) => {
  const renderContent = (
    item: BlueText | Image | Paragraph | List | BoldText,
    index: number
  ) => {
    switch (item.type) {
      case "bluetext":
        return (
          <p key={index} style={item.style} className="blog-bluetext">
            {item.text}
          </p>
        );

      case "image":
        return (
          <img
            key={index}
            src={item.path}
            alt="blog content"
            style={item.style}
            className="blog-image"
          />
        );

      case "paragraph":
        return (
          <p key={index} style={item.style} className="blog-paragraph">
            {item.text}
          </p>
        );

      case "list":
        return (
          <div key={index} style={item.style}>
            <ul className="blog-list">
              {item.listItem.map((listItem, idx) => (
                <li key={idx} className="blog-list-item">
                  <span className="blog-list-item-bold">
                    {listItem.boldtext}
                  </span>{" "}
                  {listItem.text}
                </li>
              ))}
            </ul>
          </div>
        );

      case "boldtext":
        return (
          <strong key={index} style={item.style} className="blog-boldtext">
            {item.text}
          </strong>
        );

      default:
        return null;
    }
  };

  return (
    <section className="blog-template">
      {/* Render heading */}
      <div style={heading.style} className="blog-heading">
        <div className="blog-heading-text">
          {heading.text.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
        <div className="blog-heading-date">{heading.date}</div>
      </div>

      {/* Map over content array */}
      <div className="blog-content">
        {content.map((item, index) => renderContent(item, index))}
      </div>
    </section>
  );
};

export default BlogTemplate;
